import {globalWindow} from '../../../libs/shared/helpers/src/browser/browserHelpers';

export const {performance} = globalWindow;
